module.exports = __webpack_public_path__ + "img/89e1df3.jpg";